import React, { useState, VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';

const EXPAND_SIZE = 8;

const ImageWrapper = styled.div<{ size: number; loaded: boolean }>`
  display: flex;
  justify-content: ${({ loaded }) => (loaded ? 'normal' : 'center')};
  align-items: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  margin: 4px;
  overflow: hidden;
  transition: all 0.5s;

  &:hover {
    width: ${({ size }) => size + EXPAND_SIZE}px;
    height: ${({ size }) => size + EXPAND_SIZE}px;
    margin: 0;
  }
`;
const Img = styled.img<{ width?: number; height?: number; loaded: boolean }>`
  display: ${({ loaded }) => (loaded ? 'block' : 'none')};
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  transition: all 0.5s;

  &:hover {
    width: ${({ width }) => (width ? `${width + EXPAND_SIZE}px` : 'auto')};
    height: ${({ height }) => (height ? `${height + EXPAND_SIZE}px` : 'auto')};
  }
`;

const useStyles = makeStyles({
  skeltonRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'black',
  },
});

interface Props {
  src: string;
  alt: string;
  size: number;
}
const Image: VFC<Props> = ({ src, alt, size }: Props) => {
  // atomsにあたるようなコンポーネントでは、本来はstate管理すべきではないが、
  // img要素が読み込まれたかどうかのハンドリングのために例外的に利用している
  const [loaded, setLoaded] = useState(false);
  // 取得した画像のwidthとheightを比較して、widthの方が大きい場合にtrueを返す
  const [isWidthLarge, setIsWidthLarge] = useState(true);
  const { skeltonRoot } = useStyles();
  const handleLoad = (e) => {
    const img = e.target;
    setIsWidthLarge(img.naturalWidth >= img.naturalHeight);
    setLoaded(true);
  };
  const imgSizeProps = isWidthLarge ? { height: size } : { width: size };

  return (
    <ImageWrapper size={size} loaded={loaded}>
      <Img
        src={src}
        alt={alt}
        loaded={loaded}
        onLoad={handleLoad}
        {...imgSizeProps}
      />
      {!loaded && (
        <Skeleton
          variant="rect"
          width={size}
          height={size}
          classes={{ root: skeltonRoot }}
        >
          {T.translate('homes.instagram.loading')}
        </Skeleton>
      )}
    </ImageWrapper>
  );
};

export default Image;
